var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('config-provider',{attrs:{"locale":_vm.currentLocale,"renderEmpty":_vm.renderEmpty}},[_c('router-view',{key:_vm.userId,class:_vm.$style.root})],1)}
var staticRenderFns = []

export { render, staticRenderFns }